import { CollapseMenuIcon } from '@/lib';
import { forwardRef } from 'react';
import { twMerge } from 'tailwind-merge';

type PinIconProps = {
  onClick: VoidFunction;
  classNames?: {
    button?: string;
    icon?: string;
  };
};

export const PinButton = forwardRef<HTMLButtonElement, PinIconProps>(({ onClick, classNames }, ref) => {
  return (
    <button
      ref={ref}
      onMouseOver={(e) => e.stopPropagation()}
      onFocus={() => {}}
      onClick={onClick}
      className={twMerge(
        'rounded-md size-7 mx-1.5 p-1 grid place-content-center bg-yellow-500 self-end',
        'motion-safe:transition-[background-color,margin] motion-safe:duration-500 motion-reduce:transition-none',
        'group-data-[expanded=true]/sidebar:bg-transparent group-data-[expanded=true]/sidebar:me-0 group-data-[expanded=true]/sidebar:mb-0',
        classNames?.button
      )}
    >
      <CollapseMenuIcon
        className={twMerge(
          'size-3 rotate-180 text-brand-500',
          'motion-safe:transition-[transform,color] motion-safe:duration-500',
          'group-data-[expanded=true]/sidebar:text-gray-400 group-data-[expanded=true]/sidebar:rotate-0',
          'group-data-[pinned=true]/sidebar:rotate-0',
          classNames?.icon
        )}
      />
    </button>
  );
});
